import { render, staticRenderFns } from "./PackageQuoteUpdateStatus.vue?vue&type=template&id=72584f14&"
import script from "./PackageQuoteUpdateStatus.vue?vue&type=script&lang=js&"
export * from "./PackageQuoteUpdateStatus.vue?vue&type=script&lang=js&"
import style0 from "./PackageQuoteUpdateStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackageQuoteUpdateStatus.vue"
export default component.exports